<template>
  <div class="view-site">
    <div v-if="cargando" class="text-center py-10">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <div v-else-if="!lugar" class="text-center py-10 text-grey">
      Lugar no encontrado
    </div>

    <template v-else>
      <!-- Carrusel de imágenes -->
      <v-carousel
        v-if="imagenes.length > 0"
        hide-delimiter-background
        show-arrows="hover"
        class="site-carousel mb-3"
      >
        <v-carousel-item
          v-for="img in imagenes"
          :key="img.idImagen"
          :src="img.pathBase64"
          cover
        />
      </v-carousel>

      <!-- Nombre y categorías -->
      <div class="site-header">
        <h1 class="site-nombre">{{ lugar.name }}</h1>
        <div class="site-chips">
          <v-chip
            v-for="cat in lugar.categories"
            :key="cat.idCategory"
            size="small"
            color="green"
            variant="tonal"
          >
            {{ cat.name }}
          </v-chip>
          <v-chip v-if="lugar.freeEntry" size="small" color="blue" variant="tonal">
            Entrada libre
          </v-chip>
        </div>
      </div>

      <!-- Info principal -->
      <v-card variant="outlined" class="info-card">
        <v-card-text>
          <div v-if="lugar.city || lugar.department || lugar.country" class="info-row">
            <v-icon color="grey" size="18">mdi-map-marker</v-icon>
            <span>{{ [lugar.city, lugar.department, lugar.country].filter(Boolean).join(", ") }}</span>
          </div>
          <div v-if="lugar.schedule" class="info-row">
            <v-icon color="grey" size="18">mdi-clock-outline</v-icon>
            <span>{{ lugar.schedule }}</span>
          </div>
          <div v-if="lugar.location" class="info-row">
            <v-icon color="grey" size="18">mdi-map</v-icon>
            <span>{{ lugar.location }}</span>
          </div>
          <div v-if="lugar.description" class="site-descripcion mt-3">
            {{ lugar.description }}
          </div>
        </v-card-text>
      </v-card>

      <!-- Coordenadas / mapa -->
      <v-card v-if="lugar.latitude && lugar.longitude" variant="outlined" class="info-card">
        <v-card-text>
          <div class="info-row">
            <v-icon color="grey" size="18">mdi-crosshairs-gps</v-icon>
            <span>{{ lugar.latitude }}, {{ lugar.longitude }}</span>
          </div>
          <v-btn
            color="primary"
            variant="tonal"
            size="small"
            class="mt-2"
            :href="`https://www.google.com/maps?q=${lugar.latitude},${lugar.longitude}`"
            target="_blank"
          >
            <v-icon start>mdi-google-maps</v-icon>
            Ver en Google Maps
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Vistas -->
      <div class="site-vistas">
        <v-icon size="14" color="grey">mdi-eye</v-icon>
        <span>{{ lugar.views }} vista{{ lugar.views !== 1 ? "s" : "" }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import apisSites from "@/apis/apisSites";
import { ponerTitulo } from "@/router";

export default {
  name: "ViewSiteView",
  data() {
    return {
      lugar: null,
      imagenes: [],
      cargando: true,
    };
  },
  async created() {
    const id = this.$route.params.id;
    try {
      [this.lugar, this.imagenes] = await Promise.all([
        apisSites.getById(id),
        apisSites.getImages(id),
      ]);
      apisSites.addView(id);
      ponerTitulo(this.lugar ? this.lugar.name : null);
    } catch {
      this.lugar = null;
    } finally {
      this.cargando = false;
    }
  },
};
</script>

<style scoped>
.view-site {
  max-width: 700px;
  margin: 0 auto;
  padding: 16px;
}

.site-header {
  margin-bottom: 14px;
}

.site-nombre {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.site-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.info-card {
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 0.9rem;
}

.site-descripcion {
  font-size: 0.9rem;
  color: #444;
  line-height: 1.5;
}

.site-carousel {
  border-radius: 8px;
  overflow: hidden;
  height: 260px;
}

@media (min-width: 500px) {
  .site-carousel {
    height: 320px;
  }
}

.site-vistas {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  color: #aaa;
  margin-top: 8px;
}
</style>
